import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { interfaces } from '@leandredev/dcbm-common-lib';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { DCBMFormValidatorsHelper } from 'src/app/shell/helpers/DcbmFormValidatorsHelper';
import { SignInJwtService } from 'src/app/services/signIn-jwt/signIn-jwt.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  animations: [fadeInUpAnimation]
})
export class ResetPasswordComponent implements OnInit {
  public form: FormGroup<{ password: FormControl<string>; confirmPassword: FormControl<string> }>;

  private passwordKey = '';

  constructor(
    private signInJwtService: SignInJwtService,
    private formBuilder: FormBuilder,
    private activateRoute: ActivatedRoute,
    private router: Router,
    public snackBar: MatSnackBar
  ) {
    this.form = this.formBuilder.group({
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    });

    this.form.addValidators([DCBMFormValidatorsHelper.matchingPasswords('password', 'confirmPassword')]);
  }

  public ngOnInit(): void {
    this.passwordKey = this.activateRoute.snapshot.queryParamMap.get('key') as string;
  }

  public resetPassword(): void {
    if (!this.form.valid) return;

    const changepasswordRequest: interfaces.IresetPasswordRequest = {
      password: this.form.get('password')?.value as string,
      resetPasswordKey: this.passwordKey
    };

    this.signInJwtService.resetPassword(changepasswordRequest).subscribe({
      complete: () => {
        this.displayLogin();
      },
      error: (error) => {
        this.displaySnackError(error);
      }
    });
  }

  private displayLogin(): void {
    void this.router.navigate(['/']);
  }

  private displaySnackError(error?: string): void {
    this.snackBar.open(`Nous avons rencontre un problème interne ${error}`, '×', {
      panelClass: 'error',
      verticalPosition: 'top',
      duration: 3000
    });
  }
}
